import { render, staticRenderFns } from "./DemoRatings.vue?vue&type=template&id=9c80f580&scoped=true"
import script from "./DemoRatings.vue?vue&type=script&lang=js"
export * from "./DemoRatings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c80f580",
  null
  
)

export default component.exports